@for (m of messages; track $index) {
  <div
    class="ai-chat__message"
    [class.ai-chat__message--user]="m.role === 'user'"
    [class.ai-chat__message--assistant]="m.role === 'assistant'"
    [class.ai-thread__error]="m.error"
  >
    @if (m.role === "assistant") {
      <div class="ai-chat__avatar">
        <i class="pi" [class.pi-sparkles]="!m.error" [class.pi-exclamation-triangle]="m.error"></i>
      </div>
    }
    <div class="ai-chat__bubble">
      @if (m.photos) {
        <p class="ai-thread__attachment">{{ m.photos > 1 ? m.photos + " photos jointes" : "Photo jointe" }}</p>
      }
      @for (nom of m.documents; track $index) {
        <p class="ai-thread__attachment">{{ nom }}</p>
      }
      <div [innerHTML]="m.html"></div>
    </div>
  </div>
} @empty {
  @if (!progress) {
    <ng-content></ng-content>
  }
}

@if (pending) {
  <div class="ai-chat__confirm">
    <p class="ai-chat__confirm-title">{{ pending.titre }}</p>
    <p class="ai-chat__confirm-action">{{ pending.action }}</p>
    @if (pending.lignes.length) {
      <ul class="ai-chat__confirm-lines">
        @for (line of pending.lignes; track $index) {
          <li>{{ line }}</li>
        }
      </ul>
    }
    <div class="ai-chat__confirm-buttons">
      <eva-button
        label="Refuser"
        variant="outlined"
        severity="secondary"
        [disabled]="busy"
        (onClick)="decided.emit('refuser')"
      />
      <eva-button label="Valider" severity="primary" [disabled]="busy" (onClick)="decided.emit('valider')" />
    </div>
  </div>
}

@if (progress) {
  <div class="ai-chat__message ai-chat__message--assistant">
    <div class="ai-chat__avatar">
      <i class="pi pi-sparkles"></i>
    </div>
    <div class="ai-chat__bubble ai-chat__progress">
      <div class="ai-chat__typing"><span></span><span></span><span></span></div>
      <span>{{ progress }}</span>
    </div>
  </div>
}

@if (long) {
  <div class="ai-thread__long" role="note">
    <span>Cette conversation devient longue : l'assistant va oublier le début et répondre plus lentement.</span>
    <eva-button
      label="Nouvelle conversation"
      icon="pi pi-plus"
      size="small"
      severity="primary"
      (onClick)="restart.emit()"
    />
  </div>
}
